import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup, Textarea } from "@cofano/cck";
import { Grid } from "@mui/material";
import { Language } from "imports/Utils";

export default ({ control }) => {
	return (
		<Grid xs={6} item>
			<FormGroup label={Language("LETTER_OF_PROTEST_OTHER_NOTES")} labelPlacement="left" overflow="hidden">
				<Controller
					name="protestVariables.othersNotes"
					control={control}
					render={({ field }) => <Textarea {...field} />} />
			</FormGroup>
		</Grid>
	);
};

